import type { TourDefinition } from './types'

export type TourCallback = (tour: TourDefinition) => void | Promise<void>

const callbacks = new Map<string, TourCallback>()

export const registerTourCallback = (id: string, callback: TourCallback): (() => void) => {
  callbacks.set(id, callback)
  return () => callbacks.delete(id)
}

export const runTourCallback = async (id: string | undefined, tour: TourDefinition): Promise<void> => {
  if (!id) return
  const callback = callbacks.get(id)
  if (callback) {
    await callback(tour)
    return
  }
  if (import.meta.env.DEV) console.info(`[TOURGUIDE] Callback "${id}" is not registered; placeholder completed.`)
}

registerTourCallback('triggerConfetti', (tour) => {
  if (import.meta.env.DEV) console.info(`[TOURGUIDE] triggerConfetti placeholder for "${tour.id}".`)
})

registerTourCallback('openChatDrawer', (tour) => {
  if (import.meta.env.DEV) console.info(`[TOURGUIDE] openChatDrawer placeholder for "${tour.id}".`)
})
